import {
  brandPrivacyPolicyPath,
  brandSmsOptInPath,
  brandSmsOptOutPath,
  brandTermsAndConditionsPath,
  locationPrivacyPolicyPath,
  locationSmsOptInPath,
  locationSmsOptOutPath,
  locationTermsAndConditionsPath,
} from "~/routes";

/** Whose public texting pages these are: an office's, or a brand's covering several offices. */
export type OptInOwner = { kind: "location" | "brand"; id: string };

export function optInPaths(owner: OptInOwner) {
  if (owner.kind === "brand") {
    return {
      optIn: brandSmsOptInPath(owner.id),
      optOut: brandSmsOptOutPath(owner.id),
      termsAndConditions: brandTermsAndConditionsPath(owner.id),
      privacyPolicy: brandPrivacyPolicyPath(owner.id),
    };
  }
  return {
    optIn: locationSmsOptInPath(owner.id),
    optOut: locationSmsOptOutPath(owner.id),
    termsAndConditions: locationTermsAndConditionsPath(owner.id),
    privacyPolicy: locationPrivacyPolicyPath(owner.id),
  };
}
